import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Marquee from 'react-fast-marquee';
import { Typography, CardMedia, Card, Box, CardContent } from '@mui/material';
import axios from 'axios';
import PropTypes from 'prop-types';

import SERVER_API_URL from '../../../../config';

const LIGHT_GRAY = '#f7f7f7';

const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '' : LIGHT_GRAY,
}));

const Districts = ({ gradientColor }) => {
  const [avatars, setAvatars] = useState({});
  const [districts, setDistricts] = useState([]);

  useEffect(() => {
    const getAllDistrict = async () => {
      try {
        const response = await axios.get(`${SERVER_API_URL}/landing/getDistrictInfo`);

        if (response.status === 200) {
          setDistricts(response.data);
        }
      } catch (error) {
        // console.log(error);
      }
    };

    getAllDistrict();
  }, []);

  const getAvatarById = async (id) => {
    try {
      const response = await axios.get(`${SERVER_API_URL}/getDistrictAvatar/getAvatarById/${id}`, {
        responseType: 'blob',
      });
      if (response.status === 200) {
        return URL.createObjectURL(response.data);
      }

      throw new Error('Failed to fetch avatar');
    } catch (e) {
      console.error('Error fetching avatar:', e);
      throw e;
    }
  };

  useEffect(() => {
    const getDistrictAvatars = (filteredDistricts) => {
      if (Array.isArray(filteredDistricts)) {
        filteredDistricts.forEach((district) => {
          if (!avatars[district.id]) {
            getAvatarById(district.id)
              .then((url) => {
                setAvatars((prevUrls) => ({
                  ...prevUrls,
                  [district.id]: url,
                }));
              })
              .catch((error) => {
                console.error('Error fetching avatar:', error);
              });
          }
        });
      }
    };

    getDistrictAvatars(districts);
  }, [districts, avatars]);

  return (
    <Box sx={{ mt: 0 }}>
      <Marquee direction="right" gradient="left" gradientColor={gradientColor} pauseOnClick>
        {districts &&
          districts.map((district) => {
            const avatar = avatars[district.id];
            return (
              <Box key={district.id} sx={{ width: 265, height: 265, mt: 2, mb: 1, ml: { xs: 0, sm: 1 } }}>
                <StyledCard
                  key={district.id}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    transition: 'transform 0.2s',
                    width: 250,
                    height: 250,
                    '&:hover': {
                      transform: 'scale(1.05)',
                      cursor: 'pointer',
                    },
                  }}
                >
                  {avatar && (
                    <CardMedia
                      component="div"
                      sx={{
                        // 16:9
                        pt: '56.25%',
                      }}
                      image={avatar}
                    />
                  )}
                  {!avatar && (
                    <CardMedia
                      component="div"
                      sx={{
                        // 16:9
                        pt: '56.25%',
                      }}
                      image="/assets/landing/empty_district.png"
                    />
                  )}
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography gutterBottom variant="h5" component="h2">
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography gutterBottom variant="h5" component="h2" noWrap>
                          {district.name}
                        </Typography>
                        <Typography sx={{ minWidth: 100 }} gutterBottom variant="body1" color="darkgray">
                          {district.type}
                        </Typography>
                      </Box>
                    </Typography>
                    <Typography noWrap>{district.description} </Typography>
                  </CardContent>
                </StyledCard>
              </Box>
            );
          })}
        {districts.length === 0 && <Box sx={{ width: 265, height: 265, mt: 2, mb: 1 }}> የአውራጃዎች </Box>}
      </Marquee>
    </Box>
  );
};

export default Districts;

Districts.propTypes = {
  gradientColor: PropTypes.string.isRequired,
};